// extracted by mini-css-extract-plugin
module.exports = {"attachable-btn":"registration-button__attachable-btn___1-VKz"};